<template>
  <g>
    <svg
        :id="`rectNode${ arrayIndex }`"
        :class="`rectangle ${ getClassName() }`"
        :width="dx + strokeWidth * 15"
        :height="dy + strokeWidth * 2"
        :x="cx - dx / 2 - 7"
        :y="cy - dy / 2"
        :data-index="arrayIndex"
      >
        <defs>
          <linearGradient
            id="grad1"
            x1="0%"
            y1="50%"
            x2="100%"
            y2="50%"
          >
            <stop
              offset="0%"
              style="stop-color:rgb(255,105,32);stop-opacity:1"
            />
            <stop
              offset="100%"
              style="stop-color:rgb(255,143,39);stop-opacity:1"
            />
          </linearGradient>
          <linearGradient
            id="grad2"
            x1="50%"
            y1="0%"
            x2="50%"
            y2="100%"
          >
            <stop
              offset="0%"
              style="stop-color:#414042;stop-opacity:1"
            />
            <stop
              offset="100%"
              style="stop-color:#c4c4c6;stop-opacity:1"
            />
          </linearGradient>
          <clipPath id="clip3">
            <rect
              :width="215"
              :height="177"
              :x="strokeWidth"
              :y="strokeWidth - 1"
              :rx="borderRadius"
              :ry="borderRadius"
            />
          </clipPath>
        </defs>
        <rect
          class="rectangle__node"
          :width="Math.abs(dx + strokeWidth * 15 - 2)"
          :height="Math.abs(dy - strokeWidth)"
          :x="strokeWidth"
          :y="strokeWidth"
          :data-index="arrayIndex"
          :rx="borderRadius"
          :ry="borderRadius"
        />
        <template v-if="category === null">
          <text
            class="rectangle__text"
            x="50%"
            :y="getTextPosition()"
            alignment-baseline="middle"
            text-anchor="middle"
            pointer-events="none"
          >
            {{ textBlock }}
          </text>
        </template>
        <template v-if="category < 0">
          <text
            class="rectangle__text"
            x="50%"
            y="50%"
            alignment-baseline="middle"
            text-anchor="middle"
          >
            Add new trigger
          </text>
        </template>
        <template v-if="category === actionTypes.WAIT">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 15"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="55%"
            :y="getTextPosition()"
            alignment-baseline="middle"
            text-anchor="middle"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.CONDITION">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 25 + 5"
            :y="`${32}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="55%"
            :y="getTextPosition()"
            alignment-baseline="middle"
            text-anchor="middle"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.EMAIL">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 20"
            y="29%"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="20%"
            y="55%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
          <a
            v-if="false"
            :href="model.value.detailUrl"
          >
            <text
              v-if="false"
              class="rectangle__text"
              x="20%"
              y="55%"
              alignment-baseline="right"
              text-anchor="right"
            >
              (View reports)
            </text>
          </a>
        </template>
        <template v-if="category === actionTypes.INTEGRATION">
          <path
            d="M0 5 C0 2.23858 2.23858 0 5 0 V0 V50 V50 C 2.23858 50 0 46.7614 0 44 V5 Z"
            :fill="model.icon.line"
          />
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 20"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="35"
            y="55%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.NOTIFICATION">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 20"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="35"
            y="55%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.WEBHOOK">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 20"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="45"
            y="56%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.END_AUTOMATION">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 15"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="40"
            y="56%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
        </template>
        <template v-if="category === actionTypes.GOTO">
          <image
            v-if="icon"
            class="rectangle__image"
            :width="iconSize"
            :x="dx / 15"
            :y="`${29}%`"
            :href="icon"
          />
          <text
            class="rectangle__text"
            x="40"
            y="56%"
            alignment-baseline="right"
            text-anchor="right"
          >
            {{ model.text }}
          </text>
      </template>
      </svg>
  </g>
</template>

<script>
import {
  ActionTypes,
  ActionCategories
} from '@/utils/dictionaries'

export default {
  name: 'CustomRectangle',
  props: {
    text: String,
    cx: Number,
    cy: Number,
    dx: Number,
    dy: Number,
    arrayIndex: Number,
    category: Number,
    value: String,
    content: String,
    email: String,
    model: {
      type: Object
    }
  },
  data: () => (
    {
      fontSize: 14,
      strokeWidth: 1,
      minX: 0,
      minY: 0,
      textBlock: '',
      borderRadius: 6,
      icon: ''
    }
  ),
  computed: {
    actionTypes() {
      return { ...ActionTypes }
    },
    actionCategories() {
      return ActionCategories
    },
    iconSize() {
      return this.model.icon.size ? this.model.icon.size : 20
    }
  },
  watch: {
    'model.icon'() {
      this.getIcon()
    },
    text(newVal) {
      this.textBlock = newVal
    }
  },
  mounted() {
    this.textBlock = this.text
    if (this.model) {
      if (this.model.icon.name) {
        this.getIcon()
      }
    }
  },
  methods: {
    getTextPosition() {
      if (this.category === 2 || this.category === 3) {
        return this.dx - this.fontSize * 4 + this.fontSize / 2
      }

      return '50%'
    },
    getClassName() {
      const prefix = 'rectangle-'

      switch (this.category) {
        case ActionTypes.WAIT:
          return `${prefix}wait action`
        case ActionTypes.CONDITION:
          return `${prefix}condition action`
        case ActionTypes.EMAIL:
          return `${prefix}email action`
        case ActionTypes.INTEGRATION:
          return `${prefix}integration action`
        case ActionTypes.NOTIFICATION:
          return `${prefix}notification action`
        case ActionTypes.WEBHOOK:
          return `${prefix}webhook action`
        case ActionTypes.END_AUTOMATION:
          return `${prefix}end-automation action`
        case ActionTypes.GOTO:
          return `${prefix}goto action`
        case -1:
          return `${prefix}entry`
        default:
          return `${prefix}start trigger`
      }
    },
    getIcon() {
      import(`../assets/icons/${this.model.icon.name}.svg`)
        .then(data => {
          this.icon = data
        })
        .catch(e => {
          console.log(`Error in loading icon - ${this.model.icon.name}`)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables";

$stroke-color: #818181;

$email-bg: #536177;
$email-stroke-color: #465466;
$condition-bg: #3d4256;
$integration-stroke-color: #d9d9d9;

.rectangle {
  $block: &;

  &__node {
    stroke: $stroke-color;
    stroke-width: 1px;
    cursor: pointer;
  }

  &__text {
    font-size: 12px;
    font-weight: 800;
    fill: $text-color-dark;
    cursor: pointer;
  }

  &__image {
    pointer-events: none;
  }

  &-wait {}

  &-email {
    fill: $email-bg;

    #{$block}__node {
      stroke: $email-stroke-color;
    }

    #{$block}__text {
      fill: $text-color-light;
    }
  }

  &-condition {
    stroke-width: 1px;
    cursor: pointer;
    fill: $condition-bg;

    #{$block}__text {
      fill: $text-color-light;
    }
  }

  &-integration {
    #{$block}__text {
      fill: $text-color-dark;
    }
  }

  &-notification {
    fill: #71c5ed;
    stroke: #529bc7;

    #{$block}__node {
      stroke: #4c99c3;
    }

    #{$block}__text {
      fill: $text-color-light;
      stroke: none;
    }
  }

  &-webhook {
    fill: #8c7eb3;
    box-shadow: 0 0 0 1.5px rgba(0, 0, 0, 0.12) inset, 0 4px 4px 0 rgba(0, 0, 0, 0.13);

    #{$block}__node {
      stroke: #5f5285;
    }

    #{$block}__text {
      fill: $text-color-light;
      stroke: none;
      font-size: 14px;
    }
  }

  &-end-automation {
    fill: #db5c80;

    #{$block}__node {
      stroke: #b33a5c;
    }

    #{$block}__text {
      fill: $text-color-light;
      stroke: none;
      font-size: 14px;
    }
  }

  &-goto {
    fill: #ee8d50;

    #{$block}__node {
      stroke: #c2602e;
    }

    #{$block}__text {
      fill: $text-color-light;
      stroke: none;
      font-size: 14px;
    }
  }

  &-entry {
    #{$block}__node {
      stroke-dasharray: 7, 7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomRectangle.vue